import { Controller } from '@hotwired/stimulus'
import { useClickOutside, useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ['text', 'bubble']
  static values = {
    text: String,
    translations: Object,
    currentHint: { type: String, default: '' }
  }

  connect() {
    useTransition(this)
    useClickOutside(this)
    this.textTarget.innerHTML = this.textValue.replace('\n', '<br>')
  }

  toggle() {
    this.element.classList.toggle('expanded')
  }

  openWithText(event) {
    const text = event.detail.text

    this.textTarget.innerHTML = text?.replace('\n', '<br>')

    this.element.classList.remove('hidden')
    requestAnimationFrame(() => {
      this.element.classList.add('expanded')
      this.sibilings.forEach(sibiling => {
        sibiling.element.classList.remove('expanded')
        sibiling.element.classList.add('hidden')
      })
    })
  }

  displaySuccessMessage() {
    this.bubbleTarget.classList.add('success-bubble')
    this.bubbleTarget.classList.remove('danger-bubble')
    this.bubbleTarget.innerText = this.sampleMessage('success')
    this.enter()
    this.messageValue = this.sampleMessage('success')

    setTimeout(() => {
      this.bubbleTarget.classList.remove('success-bubble')
      this.bubbleTarget.innerText = ''
    }, 3000)
  }

  displayErrorMessage() {
    this.bubbleTarget.classList.add('danger-bubble')
    this.bubbleTarget.classList.remove('success-bubble')
    this.bubbleTarget.innerText = this.sampleMessage('error')
    this.enter()
    this.messageValue = this.sampleMessage('error')

    setTimeout(() => {
      this.bubbleTarget.classList.remove('danger-bubble')
      this.bubbleTarget.innerText = ''
    }, 2000)
  }

  sampleMessage(status) {
    return this.translationsValue[status][
      Math.floor(Math.random() * this.translationsValue[status].length)
    ]
  }

  messageValueChanged() {
    this.enter()
  }

  close(e) {
    this.element.classList.remove('expanded')
  }

  clickOutside() {
    this.close()
  }

  get sibilings() {
    return this.application.controllers.filter(
      controller => controller.identifier == this.identifier && controller != this
    )
  }
}
